import {_, computed, observable} from '@api'
import {AssortmentCardBucket, AssortmentCardStore, AssortmentHeroCardStore, AssortmentRootStore, AssortmentSwatchesStore, AssortmentSwatchStore, GroupByGroupStore, HeroCardItemStore, HeroCardSecondLevelStore, HeroCardsSecondLevelStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {DEBUG_PDF} from '.'

export type AssortmentOrientationType = 'vertical' | 'horizontal'

export interface iRhRenderStore {
  id: string,
  assortmentHeroCardStore: AssortmentHeroCardStore,
  heroCardItemStore: HeroCardItemStore,
  footerStores: Array<HeroCardSecondLevelStore>
  combineStores?: Array<iRhRenderStore>
  orientation?: AssortmentOrientationType
}

export class PDFHeroCardStore extends VipLocalStore {
  constructor(stores: StoresInstance, public cardData: AssortmentCardBucket, public rootStore: AssortmentRootStore) {
    super(stores)
    this.cardStore = new AssortmentCardStore(stores, {bucket: cardData, root: rootStore})
    this.cardStore.componentStores.swatches = this.swatchesStore
    this.swatches = this.swatchesStore.swatchesToRender.map((swatch, i) => {
      const store = new AssortmentSwatchStore(stores, {card: this.cardStore, swatch, index: i})
      this.cardStore.componentStores.swatches.storesById[store.id] = store
      return store
    })
  }

  @observable.ref swatches: Array<AssortmentSwatchStore> = []

  @computed get cardsToRender(): Array<iRhRenderStore> {
    const {getAssortmentStores, cardStore: {componentStores: {heroCards: {cardsToRender}}}} = this
    DEBUG_PDF && console.log({cardsToRender})
    return _.take(cardsToRender, 7).map((data, index) => {
      const stores: iRhRenderStore = getAssortmentStores(data, index)
      if (data?.combined?.length) {
        stores.combineStores = data.combined.map((combine, i) => {
          return getAssortmentStores(combine, i + 1, true, stores.assortmentHeroCardStore)
        })
      }
      return stores
    })
  }

  getAssortmentStores = (data, index, isCombine = false, parentStore = null) => {
    const {cardStore: card, stores} = this
    const assortmentHeroCardStore: AssortmentHeroCardStore = new AssortmentHeroCardStore(stores, {data, card, isCombinedHeroComponentStore: isCombine, parentCombinedHero: parentStore, index}),
      {selectedHeroIndex, filteredHeroItems} = assortmentHeroCardStore

    const heroCardItemStore: HeroCardItemStore = new HeroCardItemStore(stores, {item: filteredHeroItems[selectedHeroIndex > filteredHeroItems.length ? filteredHeroItems.findIndex(item => item.images?.length > 0) : selectedHeroIndex], hero: assortmentHeroCardStore, index: selectedHeroIndex})
    const secondLevelStore: HeroCardsSecondLevelStore = new HeroCardsSecondLevelStore(stores, {heroKey: heroCardItemStore.hero.dataKey, heroCard: assortmentHeroCardStore}),
      footerStores: Array<HeroCardSecondLevelStore> = (secondLevelStore.secondLevelItems ?? []).map((item, i) => {
        return new HeroCardSecondLevelStore(stores, {item, index: i, secondLevelStore})
      })

    return {
      id: assortmentHeroCardStore.id,
      assortmentHeroCardStore,
      heroCardItemStore,
      footerStores,
      orientation: data?.orientation ?? ''
    }
  }

  @computed get swatchesStore(): AssortmentSwatchesStore {
    const {stores, cardStore} = this
    return new AssortmentSwatchesStore(stores, {card: cardStore})
  }

  /*@computed get swatches() {
    const {swatchesStore, cardStore, stores} = this
    return swatchesStore.swatchesToRender.map((swatch, i) => {
      const store = new AssortmentSwatchStore(stores, {card: cardStore, swatch, index: i})
      cardStore.componentStores.swatches.storesById[store.id] = store
      return store
    })
  }*/

  @observable.ref cardStore: AssortmentCardStore

}




// WEBPACK FOOTER //
// ./src/modules/pdf/PDFHeroCardStore.ts